<div class="custom-control custom-checkbox" [ngClass]="{ required: markAsRequired, valid: markAsValid }">
	<input
		class="custom-control-input"
		[ngClass]="{ 'is-invalid': isInvalid(control) }"
		type="checkbox"
		[formControl]="control"
		[id]="id"
		[tabindex]="tabIndex"
	/>

	<label class="custom-control-label" *ngIf="label" [for]="id">
		{{ label }}
	</label>
</div>
